import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Mic, CalendarPlus, Users, Plus, X } from "lucide-react";

const ACTIONS = [
  { path: "/notes", label: "AI Scribe", icon: Mic, color: "bg-forest text-white hover:bg-forest-dark" },
  { path: "/create-plan", label: "Meal Plan", icon: CalendarPlus, color: "bg-white dark:bg-slate-800 text-forest dark:text-emerald-400 border border-slate-200 dark:border-slate-700 hover:bg-forest/5" },
  { path: "/patients", label: "Patients", icon: Users, color: "bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700" },
];

export default function QuickActionsFAB() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Hide on login page and pages where FAB would overlap content
  if (location.pathname === "/login") return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col-reverse items-end gap-2" data-testid="quick-actions-fab">
      {/* Main button */}
      <button
        onClick={() => setOpen(!open)}
        className={`w-12 h-12 rounded-full shadow-lg flex items-center justify-center transition-colors duration-200 border-0 cursor-pointer
          ${open
            ? "bg-slate-800 dark:bg-slate-200 text-white dark:text-slate-900 rotate-45"
            : "bg-forest text-white hover:bg-forest-dark hover:shadow-xl hover:scale-105"
          }`}
        data-testid="fab-toggle"
      >
        {open ? <X className="w-5 h-5" /> : <Plus className="w-5 h-5" />}
      </button>

      {/* Action items */}
      {open && (
        <div className="flex flex-col gap-2 mb-1 animate-in slide-in-from-bottom-2 fade-in duration-200">
          {ACTIONS.map((action) => (
            <button
              key={action.path}
              onClick={() => { navigate(action.path); setOpen(false); }}
              className={`flex items-center gap-2.5 pl-3 pr-4 py-2.5 rounded-full shadow-md text-sm font-medium transition-colors border-0 cursor-pointer whitespace-nowrap ${action.color}`}
              data-testid={`fab-action-${action.path.replace("/", "")}`}
            >
              <action.icon className="w-4 h-4" />
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
